

export function PrivacyPolicy() {
  return (
    <div style={{ maxWidth: '800px', margin: '0 auto', padding: '40px', fontFamily: 'sans-serif', lineHeight: 1.6, color: '#e2e8f0' }}>
      <h1 style={{ color: '#fff', marginBottom: '24px' }}>VeloStruct Chrome Extension - Privacy Policy</h1>
      
      <p>Last updated: April 29, 2026</p>

      <h2 style={{ color: '#60a5fa', marginTop: '32px' }}>1. Information We Do Not Collect</h2>
      <p>
        The VeloStruct Agent Bridge Chrome Extension is designed with privacy as a fundamental principle. 
        <strong> We do not collect, store, transmit, or share any personal information, browsing history, or diagram data.</strong>
      </p>

      <h2 style={{ color: '#60a5fa', marginTop: '32px' }}>2. How the Extension Works</h2>
      <p>
        The extension exists solely to broker a local connection between your active VeloStruct tab and a locally running AI Model Context Protocol (MCP) server. 
        It establishes a WebSocket connection strictly to <code>ws://127.0.0.1:7823</code> (your own machine) to pass messages between your local AI agent (like Claude Code, Cursor, or Windsurf) and the VeloStruct web application.
      </p>

      <h2 style={{ color: '#60a5fa', marginTop: '32px' }}>3. Permissions Explained</h2>
      <ul>
        <li><strong>tabs:</strong> Required to locate the currently active VeloStruct tab so the AI can interact with the diagram you are currently viewing.</li>
        <li><strong>scripting:</strong> Required to inject the bridge script into the VeloStruct tab to facilitate the connection.</li>
        <li><strong>host permissions:</strong> Restricted strictly to VeloStruct domains to ensure the extension only runs where intended.</li>
      </ul>

      <h2 style={{ color: '#60a5fa', marginTop: '32px' }}>4. Changes to This Policy</h2>
      <p>
        If we make changes to this privacy policy, we will update the "Last updated" date at the top of this page. Because we do not collect user information, we have no way to notify users directly of changes.
      </p>

      <div style={{ marginTop: '48px', paddingTop: '24px', borderTop: '1px solid #334155' }}>
        <a href="/edit" style={{ color: '#60a5fa', textDecoration: 'none' }}>&larr; Back to VeloStruct</a>
      </div>
    </div>
  );
}
